export const SecurityIcon = () => (
  <svg
    width={'76'}
    height={'72'}
    viewBox={'0 0 76 72'}
    fill={'none'}
    xmlns={'http://www.w3.org/2000/svg'}
  >
    <rect
      x={'0.75'}
      y={'8'}
      width={'64'}
      height={'64'}
      rx={'12'}
      fill={'#001CDB'}
    />
    <path
      d={'M26.5 50C25.95 50 25.4792 49.8042 25.0875 49.4125C24.6958 49.0208 24.5 48.55 24.5 48V38C24.5 37.45 24.6958 36.9792 25.0875 36.5875C25.4792 36.1958 25.95 36 26.5 36H27.5V34C27.5 32.6167 27.9875 31.4375 28.9625 30.4625C29.9375 29.4875 31.1167 29 32.5 29C33.8833 29 35.0625 29.4875 36.0375 30.4625C37.0125 31.4375 37.5 32.6167 37.5 34V36H38.5C39.05 36 39.5208 36.1958 39.9125 36.5875C40.3042 36.9792 40.5 37.45 40.5 38V48C40.5 48.55 40.3042 49.0208 39.9125 49.4125C39.5208 49.8042 39.05 50 38.5 50H26.5ZM32.5 45C33.05 45 33.5208 44.8042 33.9125 44.4125C34.3042 44.0208 34.5 43.55 34.5 43C34.5 42.45 34.3042 41.9792 33.9125 41.5875C33.5208 41.1958 33.05 41 32.5 41C31.95 41 31.4792 41.1958 31.0875 41.5875C30.6958 41.9792 30.5 42.45 30.5 43C30.5 43.55 30.6958 44.0208 31.0875 44.4125C31.4792 44.8042 31.95 45 32.5 45ZM29.5 36H35.5V34C35.5 33.1667 35.2083 32.4583 34.625 31.875C34.0417 31.2917 33.3333 31 32.5 31C31.6667 31 30.9583 31.2917 30.375 31.875C29.7917 32.4583 29.5 33.1667 29.5 34V36Z'}
      fill={'white'}
    />
    <circle
      cx={'62.5'}
      cy={'13.5'}
      r={'13.5'}
      fill={'#00D200'}
    />
    <path
      d={'M58 13.4999L61.0659 16.7142L67 10.2856'}
      stroke={'white'}
      strokeWidth={'2.57143'}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
    />
  </svg>
);
